import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgHeight = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M9.35355 1.64645C9.15829 1.45118 8.84178 1.45118 8.64652 1.64645L5.46488 4.82809C5.26962 5.02335 5.26962 5.33986 5.46488 5.53512C5.66014 5.73038 5.97665 5.73038 6.17191 5.53512L8.50004 3.20699V14.7929L6.17191 12.4648C5.97665 12.2695 5.66014 12.2695 5.46488 12.4648C5.26962 12.6601 5.26962 12.9766 5.46488 13.1718L8.64652 16.3535C8.84178 16.5487 9.15829 16.5487 9.35355 16.3535L12.5352 13.1718C12.7305 12.9766 12.7305 12.6601 12.5352 12.4648C12.3399 12.2695 12.0234 12.2695 11.8282 12.4648L9.50004 14.7929V3.20699L11.8282 5.53512C12.0234 5.73038 12.3399 5.73038 12.5352 5.53512C12.7305 5.33986 12.7305 5.02335 12.5352 4.82809L9.35355 1.64645Z",
		fill: "black"
	})
});
export default SvgHeight;
